<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M4.4 12.9q-.7-.9 0-1.8L11 4.4q.9-.7 1.8 0l6.7 6.7a1.3 1.3 0 1 1-1.8 1.8L12 7l-5.8 6q-.9.7-1.8 0"
    />
    <path
      d="M4.4 19.6q-.7-.9 0-1.8l6.7-6.7q.9-.7 1.8 0l6.7 6.7a1.3 1.3 0 1 1-1.8 1.8L12 13.8l-5.8 5.8q-.9.8-1.8 0"
    />
  </svg>
</template>
